export default __webpack_public_path__ + "static/media/diamond-carat-4@3x.e9294f44.jpg";